export default "__VITE_ASSET__CLnWd9YV__"